import { useLazyCheckNameQuery } from "@/modules/template/services";
import { TransferKeys } from "@/modules/transaction/common/enum";
import { debounce } from "@/shared/utils";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { type Dispatch, type SetStateAction, useMemo } from "react";
import type { FieldValues, UseFormSetError } from "react-hook-form";

interface Props {
  setError?: UseFormSetError<FieldValues>;
  setIsNameUnique: Dispatch<SetStateAction<boolean>>;
}

export const useCheckTemplateName = ({ setIsNameUnique }: Props) => {
  const { trigger } = useFormProps();
  const [checkName, { isFetching }] = useLazyCheckNameQuery();

  const triggerValidation = () => {
    setTimeout(() => trigger?.(TransferKeys.TemplateName), 0);
  };

  const handleCheckTemplateName = useMemo(() => debounce((name: string) => {
    setIsNameUnique(false);
    triggerValidation();
    if (!name) {
      setIsNameUnique(true);
      return;
    }
    checkName({ name })
      .unwrap()
      .then((isUniqueName) => {
        setIsNameUnique(isUniqueName);
        triggerValidation();
      });
  }, 700), []);

  return { isFetching, handleCheckTemplateName };
};
